<template>
  <div
    @click="selectBox"
    class="item-service">

    <div class="post-head">
      <div>
        <div class="center-elements image-bg">
          <img
            v-if="image"
            width="100%"
            :src="image" />

          <div
            v-else
            class="camera-icon">

            <icon
              name="camera"
              scale="2" />

          </div>
        </div>

        <div
          v-if="isOferlayShown"
          :class="getOverlayClass">

          <div class="center-elements">
            <!-- Select post button -->
            <div
              v-if="selectable"
              class="post-selection-overlay text-center">

              <q-icon
                :allowSelfUpdate="false"
                :className="getConnectedClass"
                name="connected"
                width="45px" />

            </div>

            <!-- Edit post button -->
            <div
              v-if="editable"
              class="post-selection-overlay text-center buttons">

              <input-button
                class="mt-2 ml-2 mr-2"
                pointable
                hollow
                smaller
                variant="standardInput"
                btnStyle="ok-style"
                :inputPlaceholder="$t('Button.edit')"
                @click="editPost" />

              <input-button
                class="mt-2 ml-2 mr-2"
                pointable
                hollow
                smaller
                variant="standardInput"
                btnStyle="nok-style"
                :inputPlaceholder="$t('Button.remove')"
                @click="deletePost" />

            </div>

          </div>
        </div>
      </div>
    </div>

    <div :class="getPostContentStyle">
      {{ title }}
    </div>

    <div :class="getPostPricingStyle">
      <p>
        <b>
          <!-- Price section... -->
          <span :class="{'float-right': true}">
            <span :class="{'invalid-price': getDiscount.discount, 'price': !getDiscount.discount }">
              {{ getPrice }} EUR
            </span>

            <span
              v-if="getDiscount.discount"
              class="price">

              {{ getDiscountedPrice }} EUR
            </span>
          </span>

          <!-- Discount section... -->
          <span
            v-if="getDiscount.discount"
            class="discount-tag">

            {{ getAdvertisableDisplayDiscount }} 
          </span>

          <span
            v-if="getQuantity"
            class="float-right">

            {{ getQuantity }}x
          </span>
        </b>
      </p>
    </div>
  </div>
</template>

<script>
import item from '@/mixins/service/postList/item'

export default {
  mixins: [ item ]
}
</script>

<style scoped>
.overlay-shown {
  border: 1px solid #7AC143;
  border-bottom: none;
}
.icon-plain {
  position: relative;
  top: -200px;
  opacity: 0;
  transition: all .3s;
  width: 0;
  height: 0;
  overflow: hidden;
}
.raised {
  opacity: 1;
  top: 0;
  width: 45px;
  height: 45px;
}

.camera-icon {
  position: absolute;
  left: 20px;
  top: 20px;
  color: white;
}
.image-bg {
  background-color: #FFF;
  border: 1px solid #E3E3E3;

  background: rgba(248,248,248,1);
  background: -moz-linear-gradient(top, rgba(248,248,248,1) 0%, rgba(53,54,53,1) 100%);
  background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(248,248,248,1)), color-stop(100%, rgba(53,54,53,1)));
  background: -webkit-linear-gradient(top, rgba(248,248,248,1) 0%, rgba(53,54,53,1) 100%);
  background: -o-linear-gradient(top, rgba(248,248,248,1) 0%, rgba(53,54,53,1) 100%);
  background: -ms-linear-gradient(top, rgba(248,248,248,1) 0%, rgba(53,54,53,1) 100%);
  background: linear-gradient(to bottom, rgba(248,248,248,1) 0%, rgba(53,54,53,1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f8f8f8', endColorstr='#353635', GradientType=0 );
}
.overlay-bg {
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #00000077;
  transition: background-color .3s;
}
.overlay-hover {
  opacity: 0;
  transition: opacity .3s;
}
.item-service:hover .overlay-hover {
  opacity: 1;
}
.center-elements {
  height: 100%;
  width: 100%;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  justify-content: center;
  margin: 0;
  position: relative;
}
.center-elements.image-bg {
  min-height: 150px;

}
.post-selection-overlay {
  position: relative;
}

.post-selection-overlay.buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.post-content, .post-pricing {
  position: relative;
  height: 90px;
  padding: 17px 14px;
  border: 1px solid #E3E3E3;
  border-top: 0;
}
.selected.post-content, .selected.post-pricing {
  border: 1px solid #7AC143;
  border-top: none;
}
.post-content {
  max-height: 90px;
  overflow-y: scroll;

  font-size: 12px;
  line-height: 17px;
}
.post-content::-webkit-scrollbar {
  display: none;
}
.post-pricing {
  font-size: 11px;
  height: 50px;
}

.eur-synbol {
  margin-left: 5px;
}

.post-head {
  min-width: 110px;
  position: relative;
}
.content {
  padding: 20px;
}
.item-service {
  background-color: white;
  padding: 0;
  cursor: pointer;
}
.price {
  color: #1E1E1E!important;
  padding-top: 15px;
  height: 45px;
  max-height: 45px;
  overflow-y: scroll;

}
.invalid-price {
  text-decoration: line-through;
  color: #353635;
  font-weight: lighter;
  margin-right: 6px;
}
.discount-tag {
  border-radius: 0px 6px 6px 0px;
  color: #fff;
  display: block;
  float: right;
  padding: 3px 6px;
  background: #93274f;
  font-size: 12px;
  font-weight: 400;
  position: absolute;
  left: 0;
  bottom: 150px;
  background-color:#7AC143;
}

</style>



// WEBPACK FOOTER //
// src/components/service/postList/ItemGrid.vue?0bd2c3b4